import { dateFormat } from 'formatters/date';
import { NA } from 'interfaces/document';
import { IFile } from 'interfaces/file';
import moment from 'moment';

export function getFileExpirationDate(file: IFile) {
  if (!file.expirationDate || file.frequency === NA) {
    return '-';
  }

  const parsed = new Date(file.expirationDate);

  if (parsed.getFullYear() <= 1970 || parsed.getFullYear() >= 2099) {
    return '-';
  }

  return dateFormat(parsed);
}

export function computeExpirationTime(file: IFile) {
  if (!file.expirationDate) return null;
  const dateDiff = moment(file.expirationDate).diff(moment());
  const duration = moment.duration(dateDiff);
  const asDays = duration.asDays();
  if (asDays <= 0) return '0 dias';
  if (asDays <= 1) return '1 dia';
  return `${Math.ceil(asDays)} dias`;
}

export function getFileExpirationTime(file: IFile) {
  const expirationDate = getFileExpirationDate(file);

  if (expirationDate === '-') {
    return '-';
  }

  return computeExpirationTime(file);
}